import BracketAnalytics from '../../components/moment/BracketAnalytics';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { store } from 'store/createStore';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../../consts';

import { fetchUsersInteraction, setShowAnonymousUsers } from '../../modules';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
  setShowAnonymousUsers(data) {
    dispatch(setShowAnonymousUsers(data));
  },
});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedTab', 'updateSelectedTab', 0),
  withState('momentsList', 'setMomentsList', []),
  withState('bracketData', 'setBracketData', []),
  withState('tableRef', 'setTableRef', null),
  withState('dataReport', 'setDataReport', []),
  withState('entriesStarted', 'setEntriesStarted', 0),
  withState('entriesCompleted', 'setEntriesCompleted', 0),
  withState('entriesCompletedPercentage', 'setEntriesCompletedPercentage', 0),
  withState('filteredEntries', 'setFilteredEntries', 0),
  withState('columnMaterialTable', 'setColumnMaterialTable', []),
  withState('filteredEntries', 'setFilteredEntries', 0),
  withState('filteredEntriesPercentage', 'setFilteredEntriesPercentage', 0),
  withHandlers({
    setTableColumn: props => (data, gridSize) => {
      let columns = [];
      let objLookup = {};

      data.map(team => (objLookup[team.name] = team.name));

      for (let i = 1; i <= gridSize - 1; i++) {
        const newColumn = {
          title: 'G' + i,
          field: `games.${i}.answerName`,
        };
        columns.push(newColumn);
      }
      props.setColumnMaterialTable(columns);
    },
  }),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
    getTeams: props => (leagueId, gridSize) => {
      let query = { leagues: leagueId };
      API.getTeams({
        query: JSON.stringify(query),
        select: 'teamId name',
      }).then(({ data }) => {
        if (data && data.docs) {
          props.setTableColumn(data.docs, gridSize);
        }
      });
    },
    getBracketAnalytics: props => (interactionId, filter, per_page, page) => {
      const { currentGroup } = store.getState().auth;

      return API.getBracketAnalytics({
        group: currentGroup._id,
        interaction: interactionId,
        filter,
        per_page,
        page,
      }).then(dataAnalytics => {
        if (dataAnalytics.bracketData) {
          props.setEntriesStarted(dataAnalytics.entriesStarted);
          props.setEntriesCompleted(dataAnalytics.entriesCompleted);
          props.setEntriesCompletedPercentage(dataAnalytics.entriesCompletedPercentage);
          props.setFilteredEntries(dataAnalytics.filteredEntries);
          props.setFilteredEntriesPercentage(dataAnalytics.filteredEntriesPercentage);
        }
        return dataAnalytics;
      });
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {
      if (this.props.interaction) {
        const leagueId = _.get(this.props.interaction, 'params.leagueId', null);
        const gridSize = _.get(this.props.interaction, 'params.gridSize', 0);
        if (leagueId) {
          this.props.getTeams(leagueId, gridSize);
        }
      }
    },
  })
);

export default enhance(BracketAnalytics);
